import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class InitiativesTableThemeSelectorComponent extends Component {
  @tracked themeFormIsVisible = false;
  selectedInitiative = null;

  get initiative() {
    return this.args.initiative;
  }

  @action
  handleThemeChange(initiative, e) {
    if (e.id === 'clear') {
      initiative.theme = undefined;
    } else initiative.theme = e;
    initiative.save();
  }

  @action
  toggleThemeForm(initiative, val) {
    if (initiative) this.selectedInitiative = initiative;
    else this.selectedInitiative = null;
    if (val !== undefined) this.themeFormIsVisible = val;
    else this.themeFormIsVisible = !this.themeFormIsVisible;
  }

  @action
  async onThemeAdded(theme) {
    this.selectedInitiative.theme = theme;
    await this.selectedInitiative.save();
  }

  willDestroy() {
    this.themeFormIsVisible = false;
    this.selectedInitiative = null;
    super.willDestroy(...arguments);
  }
}
